import { createAction, props } from "@ngrx/store";
import { IsNumber } from "class-validator";

/**
 * Load Generic Collection Actions
 */

export const loadGenericWithoutId = (actionType: string) =>
  createAction(
    `[${actionType}] Load ${actionType} WithoutId Load`,
    props<{ modelType: string }>(),
);

export const loadGenericWithoutIdSuccess = (actionType: string) =>
  createAction(
    `[${actionType}] Load ${actionType} WithoutId Data Success`,
    props<{ returnedData: any[] }>(),
);

export const loadGenericWithoutIdFailure = (actionType: string) =>
  createAction(
    `[${actionType}] Load ${actionType} WithoutId Data Failure`,
    props<{ error: any }>(),
);


  /**
 * Load Generic Collection Actions
 */

export const loadGeneric = (actionType: string) =>
  createAction(
    `[${actionType}] Load ${actionType} Load`,
    props<{ modelType: string, id: string }>(),
);

export const loadGenericSuccess = (actionType: string) =>
  createAction(
    `[${actionType}] Load ${actionType} Data Success`,
    props<{ returnedData: any[] }>(),
);

export const loadGenericFailure = (actionType: string) =>
  createAction(
    `[${actionType}] Load ${actionType} Data Failure`,
    props<{ error: any }>(),
);


export const loadByIdGeneric = (actionType: string) =>
  createAction(
    `[${actionType}] Load ${actionType} Data`,
    props<{ modelType: string; id: string }>(),
);

export const loadByIdGenericSuccess = (actionType: string) =>
  createAction(
    `[${actionType}] Load ${actionType} Data Success`,
    props<{ returnedData: any[] }>(),
);

export const loadByIdGenericFailure = (actionType: string) =>
  createAction(
    `[${actionType}] Load ${actionType} Data Failure`,
    props<{ error: any }>(),
);

export const addGeneric = (actionType: string) =>
  createAction(
    `[${actionType}] Add ${actionType} Data`,
    props<{ dataToAdd: any[]; modelType: string }>(),
);

export const addGenericSuccess = (actionType: string) =>
  createAction(
    `[${actionType}] Add ${actionType} Data Success`,
    props<{ returnedData: any[] }>(),
);

export const addGenericFailure = (actionType: string) =>
  createAction(
    `[${actionType}] Add ${actionType} Data Failure`,
    props<{ error: any }>(),
);

export const removeGeneric = (actionType: string) =>
  createAction(
    `[${actionType}] Remove ${actionType} Data`,
    props<{ ids: string[]; modelType: string }>(),
);

export const removeGenericSuccess = (actionType: string) =>
  createAction(
    `[${actionType}] Remove ${actionType} Data Success`,
    props<{ ids: string[] }>(),
);

export const removeGenericFailure = (actionType: string) =>
  createAction(
    `[${actionType}] Remove ${actionType} Data Failure`,
    props<{ error: any }>(),
);

export const updateGeneric = (actionType: string) =>
  createAction(
    `[${actionType}] Update ${actionType} Data`,
    props<{ dataToAdd: any[]; deletedData: any[]; modelType: string }>(),
);

export const updateGenericSuccess = (actionType: string) =>
  createAction(
    `[${actionType}] Update ${actionType} Data Success`,
    props<{ returnedData: any[] }>(),
);

export const updateGenericFailure = (actionType: string) =>
  createAction(
    `[${actionType}] Update ${actionType} Data Failure`,
    props<{ error: any }>(),
);


export const loadGenericClearState = (actionType: string) =>
  createAction(
    `[${actionType}] CLear ${actionType}  CLear State`,
    props<{ modelType: any }>(),
);

export const loadGenericClearStateSuccess = (actionType: string) =>
  createAction(
    `[${actionType}] CLear ${actionType}  CLear State Success`,
    props<{ returnedData: any[] }>(),
);
